import React, { useState } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import { useCourse } from '../contexts/CourseContext';
import { CFormLabel } from '@coreui/react';

function CourseSelection({ value, onChange, className, labelClassName, multiSelect = true, required = false, error = false }) {
    const requiredIcon = required ? <span className="text-danger">*</span> : null;

    const { getAllCourses } = useCourse();

    const [totalRenderedRecords, setTotalRenderedRecords] = useState(0)
    const [filter, setFilter] = useState({
        limit: 50,
        totalRenderedRecords: totalRenderedRecords,
        filter: null
    });

    const fetchCourses = async (searchValue, loadedOptions, { totalRenderedRecords }) => {
        try {
            const response = await getAllCourses({ ...filter, filter: searchValue, totalRenderedRecords });

            if (response.totalPages > 0) {
                const newOptions = response.courses.length > 0 && response.courses.map((course) => ({
                    label: course.name,
                    value: course.id,
                }));

                const hasMore = totalRenderedRecords + newOptions.length < response.totalCount;

                return {
                    options: newOptions,
                    hasMore: hasMore,
                    additional: {
                        totalRenderedRecords: totalRenderedRecords + filter.limit,
                    },
                };
            } else {
                return {
                    options: [],
                    hasMore: false,
                    additional: null,
                };
            }
        } catch (error) {
            console.error('Error fetching courses', error);
            return {
                options: [],
                hasMore: false,
                additional: null,
            };
        }
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            whiteSpace: state.isFocused ? 'pre-wrap' : 'nowrap',
            wordBreak: state.isFocused ? 'break-all' : null,
            wordWrap: state.isFocused ? 'break-word' : null,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }),
    };

    return (
        <div className={className}>
            <div className={labelClassName}>
                <CFormLabel>Course {requiredIcon}</CFormLabel>
            </div>
            <div className='w-100'>
                <AsyncPaginate
                    className={`${(error && required) && 'multiSelect_error'} `}
                    value={value}
                    loadOptions={fetchCourses}
                    isMulti={multiSelect}
                    isClearable={value ? value.value : false}
                    closeMenuOnSelect={!multiSelect ? true : false}
                    onChange={onChange}
                    placeholder='Select courses...'
                    noOptionsMessage={() => ('No courses found')}
                    loadingMessage={() => ('Courses Loading...')}
                    additional={{
                        totalRenderedRecords: totalRenderedRecords,
                    }}
                    SelectProps={{
                        isSearchable: true,
                    }}
                    menuShouldScrollIntoView={false}
                    menuPortalTarget={document.querySelector('body')}
                    styles={customStyles}
                />
                {(error && required) && <span className="text-danger error_message">Please select any one course.</span>}
            </div>
        </div>
    );
}

export default CourseSelection